<div class="card mt-3">
  <div class="card-content">
    <div class="card-head p-0 mt-2">
      <div class="title font-24 fontSemiBold">
        {{'content3.zatca config' | translate}}
      </div>
      <div>
        <button type="button" class="btn btn-with-icon-transparent" (click)="openZatcaForm()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
    </div>
    <div class="card-content px-0">
      <div class="row">
        <div class="col-sm-12 py-2">
          <span class="grey-color font-14">{{'content3.Seller Name' | translate}}</span>
          <div class="fontMedium">{{restaurantProfile?.restaurantZatcaConfiguration?.zatcaSellerName || '-'}}</div>
        </div>
        <div class="col-sm-4 py-2">
          <span class="grey-color font-14">{{'content3.Mode' | translate}}</span>
          <div class="fontMedium">{{restaurantProfile?.restaurantZatcaConfiguration?.zatcaConfigMode || '-'}}</div>
        </div>
        <div class="col-sm-4 py-2">
          <span class="grey-color font-14">{{'content5.Type' | translate}}</span>
          <div class="fontMedium">{{restaurantProfile?.restaurantZatcaConfiguration?.zatcaConfigrationType || '-'}}</div>
        </div>
        <div class="col-sm-4 py-2">
          <span class="grey-color font-14">{{'forms.Date' | translate}}</span>
          <div class="fontMedium">{{(restaurantProfile?.restaurantZatcaConfiguration?.zatcaConfigrationdate | date: 'dd MMMM, yyyy') || '-'}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
